import { spacings, responsiveBreakPoints } from '@styles/DesignVariables';
import styled from 'styled-components';
const { maxTablet } = responsiveBreakPoints;

interface DiscountLabelWrapperProps {
	$backgroundColor?: string;
	$marginBottom?: string;
}

interface DiscountLabelTextProps {
	$textColor?: string;
}

export const DiscountLabelWrapper = styled.div<DiscountLabelWrapperProps>`
	display: flex;
	padding: ${spacings.s4} ${spacings.s12};
	align-items: center;
	justify-content: center;
	gap: ${spacings.s4};
	border-radius: 10px;
	background: ${({ $backgroundColor }) => $backgroundColor};
	margin-bottom: ${spacings.s12};
	width: fit-content;
	margin: 0 auto ${({ $marginBottom }) => $marginBottom ?? '12px'} auto;
	@media screen and (${maxTablet}) {
		margin: 0 auto 8px auto;
	}
`;

export const DiscountLabelText = styled.p<DiscountLabelTextProps>`
	color: ${({ $textColor }) => $textColor};
	text-align: center;
	font-size: 14px;
	font-weight: 700;
	line-height: 16px; /* 114.286% */
	margin-bottom: 0 !important;
`;
